import { render, staticRenderFns } from "./learninglist.vue?vue&type=template&id=576c57b9"
import script from "./learninglist.vue?vue&type=script&lang=js"
export * from "./learninglist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports